goog.provide("shadow.js.shim.module$src$svg$wpp$filter$tune_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$filter$tune_svg");
shadow.js.shim.module$src$svg$wpp$filter$tune_svg = shadow.js.nativeProvides["src/svg/wpp/filter/tune.svg"] = shadow$bridge("src/svg/wpp/filter/tune.svg");
module$shadow_js_shim_module$src$svg$wpp$filter$tune_svg.default = shadow.js.shim.module$src$svg$wpp$filter$tune_svg;
